import { render, staticRenderFns } from "./UserPicklDetailsPopupOverview.vue?vue&type=template&id=de4b0706&scoped=true&"
import script from "./UserPicklDetailsPopupOverview.vue?vue&type=script&lang=js&"
export * from "./UserPicklDetailsPopupOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserPicklDetailsPopupOverview.vue?vue&type=style&index=0&id=de4b0706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4b0706",
  null
  
)

export default component.exports